import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import {
  getNotifications,
  markAllRead,
  markOneRead,
  clearNotifications
} from "../utils/notifications";
const typeIcon = {
  free_limit: "\u26A0\uFE0F",
  plan_upgrade: "\u2705",
  plan_expired: "\u23F0",
  info: "\u{1F4A1}"
};
const NotificationsPanel = ({ onClose, onUnreadChange }) => {
  const { t, i18n } = useTranslation();
  const isAr = i18n.language === "ar";
  const [notifs, setNotifs] = useState([]);
  const panelRef = useRef(null);
  const reload = () => {
    setNotifs(getNotifications());
    onUnreadChange?.();
  };
  useEffect(() => {
    setNotifs(getNotifications());
    onUnreadChange?.();
    const handleClickOutside = (e) => {
      if (panelRef.current && !panelRef.current.contains(e.target)) onClose();
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [onClose, onUnreadChange]);
  const handleReadAll = () => {
    markAllRead();
    reload();
  };
  const handleReadOne = (id) => {
    markOneRead(id);
    reload();
  };
  const handleClear = () => {
    clearNotifications();
    setNotifs([]);
    onUnreadChange?.();
  };
  const fmtTime = (ts) => {
    const d = new Date(ts);
    const now =  new Date();
    const diff = (now - d) / 1e3;
    if (diff < 60) return isAr ? "\u0627\u0644\u0622\u0646" : "Just now";
    if (diff < 3600) return isAr ? `${Math.floor(diff / 60)} \u062F` : `${Math.floor(diff / 60)}m ago`;
    if (diff < 86400) return isAr ? `${Math.floor(diff / 3600)} \u0633` : `${Math.floor(diff / 3600)}h ago`;
    return d.toLocaleDateString(isAr ? "ar-EG" : "en-US", { month: "short", day: "numeric" });
  };
  const hasUnread = notifs.some((n) => !n.read);
  return <div ref={panelRef} className="notifications-panel-root">
      <div className="notifications-panel-header">
        <span className="notifications-panel-title">{t("notificationsTitle")}</span>
        <div className="notifications-panel-actions">
          {hasUnread && <button type="button" className="notifications-panel-link" onClick={handleReadAll}>
              {t("notificationsReadAll")}
            </button>}
          {notifs.length > 0 && <button type="button" className="notifications-panel-link-muted" onClick={handleClear}>
              {t("notificationsClearAll")}
            </button>}
        </div>
      </div>
      <div className="notifications-panel-body">
        {notifs.length === 0 ? <div className="notifications-panel-empty">{t("notificationsEmpty")}</div> : notifs.map((n) => <div key={n.id} className="notifications-panel-row">
              <span className="notifications-panel-icon" aria-hidden>
                {typeIcon[n.type] || "\u{1F4AC}"}
              </span>
              <div className="notifications-panel-text">
                <div className="notifications-panel-heading">
                  {isAr ? n.titleAr : n.titleEn}
                </div>
                <div className="notifications-panel-bodytext">
                  {isAr ? n.bodyAr : n.bodyEn}
                </div>
                <div className="notifications-panel-meta">{fmtTime(n.timestamp)}</div>
              </div>
              {!n.read && <button
    type="button"
    className="notifications-panel-read-one"
    onClick={() => handleReadOne(n.id)}
  >
                  {t("notificationsRead")}
                </button>}
            </div>)}
      </div>
    </div>;
};
var stdin_default = NotificationsPanel;
export {
  stdin_default as default
};
